/**
 * Render a component if it matches a given breakpoint
 */

import React from 'react'
import { string } from 'prop-types'
import { getBreakpoint } from './breakpoints'

class MatchChart extends React.Component {
  static contextTypes = {
    breakpoint: string
  }

  getBreakpointName(width) {
    const { breakpoint } = this.context

    return breakpoint || getBreakpoint(width)
  }

  // Only ever update this component if the breakpoint name
  // actually changes
  shouldComponentUpdate({ width }) {
    return this.getBreakpointName(width)
  }

  render() {
    const { children, breakpoint, width } = this.props

    if (this.getBreakpointName(width) === breakpoint) {
      return Array.isArray(children) ? <g>{children}</g> : children
    }

    return null
  }
}

export default MatchChart



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/match-chart.js